.a4{min-width:0px;}